import {useQuery, type UseQueryOptions} from '@tanstack/react-query';

type Options<TData, TError> = UseQueryOptions<TData, TError>

export function useCustomQuery<TData, TError>(options: Options<TData, TError>) {
	return useQuery<TData, TError>(options);
}
